import { createContext } from "react";

const PaginationContext = createContext();

export default PaginationContext;